<template>
    <tr>
      <td data-label="Reference #">
        <router-link :to="{ path: '/quote/' + quote.uuid }" >
          <strong>
            {{ quote.reference }}
          </strong>
        </router-link>
        <br/>
        <span class="text-muted" v-if="quote.PBGrDiscountApprover"><i class="far fa-user" /> {{ quote.PBGrDiscountApprover.fullName }}</span>
      </td>
      <td data-label="Status">
        <span :class="status.class" class="badge">
          {{ status.text }}
        </span>
        <br/>
        <span class="badge-default badge">
          {{ propertyTypeName }}
        </span>
        <template v-if="quote.expired">
          <br/>
          <span class="badge-dark badge">
            Expired
          </span>
        </template>
      </td>
      <td data-label="Property Address">
        {{ quote.address }}
      </td>
      <td data-label="Quote Type">
        {{ quote.QuoteType.quoteName }}
      </td>
      <td data-label="Requested">
        {{ quote.Customer.dropdownLabel }} <br/>
        <span class="text-muted">{{ dateRequested }}</span>
      </td>
      <td data-label="Sent">
        <template v-if="quote.PBGrEmailSender">
          {{ quote.PBGrEmailSender.fullName }} <br/>
          <span class="text-muted">{{ dateSent }}</span>
        </template>
      </td>
      <td class="button-2 text-center">
        <router-link
          :to="{ path: 'editPBGquote/' + quote.uuid, append: true }"
          class="my-1 btn btn-warning">
          <i class="far fa-fw fa-edit" /> Review
        </router-link>
        <download-input
          v-if="quote.QuotePdf"
          :options="{ button: true, permalink: 'downloadFile', label: 'Download' }"
          :value="{ objectKey: quote.QuotePdf ? quote.QuotePdf.objectKey : '' }" />
        <router-link v-if="quote.QuotePdf"
          target="_blank"
          :to="{ path: '/api/public/pdf/' + quote.uuid + '?m=Quote' }"
          class="my-1 btn btn-info">
          <i class="fa fa-fw fa-search" /> Preview
        </router-link>
        <button
          v-if="quote.QuotePdf"
          class="my-1 btn btn-primary"
          @click="send()">
          <i class="far fa-fw fa-paper-plane" /> Email
        </button>
      </td>
    </tr>

</template>

<script>
  import DownloadInput from '@/components/inputs/DownloadInput'
  import {
    SEND_PBG_QUOTE
  } from '@/vuex/types'
  export default {
    name: 'PriceGuaranteeQuoteRow',
    props: {
      object: {
        type: Object
      }
    },
    components: {
      DownloadInput
    },
    data () {
      return {
        token: ''
      }
    },
    computed: {
      status () {
        if (this.quote.resolvedPBG) {
          return { class: 'badge-success', text: 'Served' }
        } else {
          return { class: 'badge-warning', text: 'Pending' }
        }
      },
      propertyTypeName () {
        let name = 'default'
        switch (this.quote.propertyType) {
          case 1:
            name = 'Residential'
            break
          case 2:
            name = 'Commercial'
            break
          case 3:
            name = 'Industrial'
            break
        }
        return name
      },
      formData () {
        return JSON.stringify({ quoteUuid: this.quote.uuid })
      },
      dateRequested () {
        return moment(this.quote.createdAt).format('dddd Do of MMMM YYYY hh:mm A')
      },
      dateSent () {
        return this.quote.sentDatePBG ? moment(this.quote.sentDatePBG).format('dddd Do of MMMM YYYY hh:mm A') : ''
      },
      quote () {
        return {
          QuotePdf: {},
          QuoteType: {},
          Customer: {},
          PBGrEmailSender: {},
          PBGrDiscountApprover: {},
          ...this.object
        }
      }
    },
    methods: {
      async send () {
        await this.$store.dispatch(SEND_PBG_QUOTE, this.quote.uuid)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/rows/PriceGuaranteeQuoteRow.vue